// src/icons/svgs/reset.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgReset = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 36, height: 36, fill: "none", viewBox: "0 0 36 36", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M1.61 5.541v9.333h9.334" }),
  /* @__PURE__ */ jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M5.515 22.652A14 14 0 1 0 8.83 8.092L1.61 14.874" })
] });
var ForwardRef = forwardRef(SvgReset);
var reset_default = ForwardRef;
export {
  reset_default as Reset
};
